import { InjectionToken } from "@angular/core";

export interface GeoZonesEndpoints {
    searchAirspaceElements: string;
    wsAirspaceTopicName: string;
    historicalAvailability: string;
    riskTimetable: string;
    getDronePoints: string;
    getDronePointDetails: string;
    getDronePointPhoto: string;
    getMaxRiskTimetable: string;
}
export const GEO_ZONES_ENDPOINTS = new InjectionToken<GeoZonesEndpoints>("Geo zones endpoints");
